import { inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { CanActivateFn, Router } from '@angular/router';
import { OrganisationRoleModel } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/organisation-role/models/organisation-role.model';
import { OrganisationRoleService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/organisation-role/services/organisation-role.service';
import { ProductService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/product/services/product.service';
import { SubscriptionService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/subscription/services/subscription.service';
import { TenantRoleService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant-role/services/tenant-role.service';
import { UsersSnackbarService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/shared/services/users-snackbar/users-snackbar.service';

export const privateGuard: CanActivateFn = async () => {
  const angularFireAuth = inject(AngularFireAuth);
  const router = inject(Router);
  const organisationRoleService = inject(OrganisationRoleService);
  const productService = inject(ProductService);
  const subscriptionService = inject(SubscriptionService);
  const tenantRoleService = inject(TenantRoleService);
  const usersSnackbarService = inject(UsersSnackbarService);

  const getCurrentUser = async () => angularFireAuth.currentUser;

  // If logout already happened (or is in-flight), avoid calling role APIs.
  if (!(await getCurrentUser())) {
    return router.createUrlTree(['identity']);
  }

  try {
    try {
      await tenantRoleService.loadRole();
    } catch (e) {
      usersSnackbarService.open('Unable to log in. There was an error loading user tenant roles.');
      throw e;
    }

    try {
      if (!(await getCurrentUser())) {
        return router.createUrlTree(['identity']);
      }

      const organisationRoles =
        (await organisationRoleService.getRoles()) as OrganisationRoleModel[];
      const persistentOrgRoleId = localStorage.getItem('activeOrganisationRoleID');
      if (persistentOrgRoleId) {
        let found = false;
        for (const [i, org] of organisationRoles.entries()) {
          if (org.organisationId === persistentOrgRoleId) {
            found = true;
            await organisationRoleService.setCurrentRole(organisationRoles[i]);
          }
        }
        if (!found) {
          localStorage.setItem('activeOrganisationRoleID', organisationRoles[0].organisationId);
          await organisationRoleService.setCurrentRole(organisationRoles[0]);
        }
      } else {
        localStorage.setItem('activeOrganisationRoleID', organisationRoles[0].organisationId);
        await organisationRoleService.setCurrentRole(organisationRoles[0]);
      }
    } catch (e) {
      usersSnackbarService.open(
        'Unable to log in. There was an error loading user organisation roles.',
      );
      throw e;
    }

    try {
      if (!productService.ownedProductsList.value.length) {
        // TODO: Defaulting to 1 to work with IRJ. This will need an /:orgId/count endpoint for future clients.
        await subscriptionService.createTrialSubscription(
          organisationRoleService.currentOrganisationRoleSubject.value.organisationId,
          1,
        );
      }
    } catch {
      // router.createUrlTree(['upgrade']);
    }

    return true;
  } catch {}

  await angularFireAuth.signOut();
  return router.createUrlTree(['identity']);
};
